import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldTypePipe } from './pipes/fieldType.pipe';
import { FieldStatusPipe } from './pipes/fieldStatus.pipe';
import { TriggerPipe } from './pipes/trigger.pipe';
import { RuleActionPipe } from './pipes/ruleAction.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { GenerateReportModalComponent } from './widgets/generate-report-modal/generate-report-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickStopDirective } from './directives/click-stop.directive';
import { CheckPermissionsDirective } from './directives/check-permissions.directive';
import { ProjectStatusPipe } from './pipes/project-status.pipe';
import { EllipsisTooltipDirective } from './directives/ellipsis-tooltip.directive';
import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';

@NgModule({
  declarations: [FieldTypePipe, FieldStatusPipe, TriggerPipe, RuleActionPipe, GroupByPipe,
    GenerateReportModalComponent, ClickStopDirective, CheckPermissionsDirective, ProjectStatusPipe,
    FeatureFlagDirective,
    EllipsisTooltipDirective,
    AutoFocusDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,

  ],
  exports: [FieldTypePipe, FieldStatusPipe, TriggerPipe, RuleActionPipe, GroupByPipe,
    GenerateReportModalComponent, ClickStopDirective, CheckPermissionsDirective, ProjectStatusPipe,
    EllipsisTooltipDirective,
  FeatureFlagDirective, AutoFocusDirective]

})
export class SharedModule { }
